import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aed25a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-box" }
const _hoisted_2 = {
  key: 0,
  class: "btn-box"
}

import { onMounted, ref, watch } from 'vue';
  import { Offcanvas } from 'bootstrap';
  import { Menu } from '@/types/menu';
  import { authStore } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';
  import MineSidebar from '@/views/mine/components/sidebar.vue';


  interface IProps {
    visible?: boolean
  }

  interface Emits {
    (event: 'update:visible', visible: boolean): boolean;
    (event: 'hide'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "hide"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:visible', visible: boolean): boolean;
    (event: 'hide'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    visible?: boolean
  }

  const { t } = useI18n();
  const  offcanvasRef = ref();
  let offcanvasInstance: Offcanvas;
  const router = useRouter();

  
  

  function close(item?: Menu) {
    if (item && Array.isArray(item.children)) {
      return;
    }
    emits('update:visible', false);
    emits('hide');
  }

  function handleSignOut() {
    close();
    authStore.signOut();
    router.replace({ name: 'login' });
  }

  onMounted(() => {
    offcanvasInstance = new Offcanvas(offcanvasRef.value, { keyboard: false });
    offcanvasRef.value.addEventListener('hide.bs.offcanvas', () => {
      close();
    });
    Boolean(props.visible) ? offcanvasInstance.show() : offcanvasInstance.hide();
  });

  watch(() => props.visible, val => {
    Boolean(val) ? offcanvasInstance.show() : offcanvasInstance.hide();
  });

return (_ctx: any,_cache: any) => {
  const _component_AppSsoLoginPartner = _resolveComponent("AppSsoLoginPartner")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "offcanvasRef",
    ref: offcanvasRef,
    class: "mobille-sidebar offcanvas offcanvas-start"
  }, [
    _createVNode(MineSidebar, {
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "sign-out",
        onClick: handleSignOut
      }, _toDisplayString(_unref(t)('Sign out')), 1)
    ]),
    (_unref(authStore).user.company_account_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AppSsoLoginPartner, { class: "sign-out" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Sign In Partner')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})